import { Box } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';

import {
  testimonialAuthorSx,
  testimonialCommentSx,
  testimonialImageSx,
} from '../../homeSsrStyles';

function Testimonial({ author, pic, pic2x, company, comment, width }) {
  return (
    <Box sx={{ textAlign: 'center' }}>
      <Box component="p" sx={testimonialCommentSx}>
        {comment}
      </Box>
      <Box
        component="img"
        src={pic}
        alt={author}
        srcSet={`${pic} ${width}w, ${pic2x} ${width * 2}w`}
        sx={testimonialImageSx}
      />
      <Box component="span" sx={testimonialAuthorSx}>
        {author} - {company}
      </Box>
    </Box>
  );
}

Testimonial.propTypes = {
  author: PropTypes.string.isRequired,
  company: PropTypes.string.isRequired,
  comment: PropTypes.string.isRequired,
  pic: PropTypes.string.isRequired,
  pic2x: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
};

export default Testimonial;
